import { HeadlineWrapperProps } from '@/components/headline-wrapper/types';
import { Headline } from '@/components/headline/Headline';
import { Link } from '@/components/link/Link';
import SerializeDescription from '@/components/serialize-description/SerializeDescription'; // Adjust the import path as necessary
import clsx from 'clsx';
import { renameDomProps } from '@/utils/sanitizeDomProps';

export function HeadlineWrapper({
  headline,
  subtitle,
  description,
  link,
  position = 'left',
  className,
  classNameDescription,
  theme,
  spacingTop,
  spacingBottom,
  sectionId,
  ...rest
}: HeadlineWrapperProps) {
  const alignmentClass = clsx({
    'items-start text-left': position === 'left',
    'items-center text-center': position === 'center',
    'items-end text-right': position === 'right',
  });
  const renamedProps = renameDomProps(rest);
  const localTheme = theme === 'dark' ? 'bg-brand-100' : 'bg-white';

  return (
    <div
      id={sectionId}
      className={clsx(
        'relative',
        localTheme,
        spacingTop && spacingBottom
          ? 'py-4 md:py-8 lg:py-20'
          : spacingTop
            ? 'pt-4 md:pt-8 lg:pt-20'
            : spacingBottom
              ? 'pb-4 md:pb-8 lg:pb-20'
              : '',
        className,
      )}
    >
      <div
        data-component-id="C010"
        className="wrapper relative z-10 mx-auto px-4 sm:px-0"
        {...renamedProps}
      >
        <div
          className={clsx('container mx-auto flex flex-col', alignmentClass)}
        >
          {headline && (
            <Headline {...headline} className="mb-4 text-brand-700">
              {headline.title}
            </Headline>
          )}
          {subtitle && (
            <p className="subtitle mt-1 text-gray-600">{subtitle}</p>
          )}
          {description && (
            <div
              className={clsx(
                'headline-content mt-2 sm:w-1/2',
                classNameDescription,
              )}
            >
              {description && (
                <SerializeDescription description={description} />
              )}
            </div>
          )}
          {link && (
            <Link {...link} className="mt-4 w-max">
              {link.title}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
